
import Request from './request';


async function fetch(data) {
    return Request('get', "api/suppliers", data);
}
async function fetchOne(id) {// 获取单个
    return Request('get', "api/suppliers/" + id);
}




export default {
    fetch,
    fetchOne,
    
};